import { ActionTypes } from '../actions'

export const rootReducer = (state, action) => {
  switch (action.type) {
    case ActionTypes.TOGGLE_CATEGORY:
      return {
        ...state,
        buttons: state.buttons.map(btn =>
          (btn.id === action.payload.categoryId)
            ? { ...btn, checked: !btn.checked }
            : btn
        ),
      };

    case ActionTypes.REORDER_SUBCATEGORIES:
      const { reorderedSubcategories } = action.payload;

      return {
        ...state,
        buttons: state.buttons.map(btn => {
          const updatedBtn = reorderedSubcategories.find(sub => sub.id === btn.id);
          return updatedBtn ? updatedBtn : btn;
        }),
      };

    case ActionTypes.REORDER_CATEGORIES:
      return {
        ...state,
        buttons: state.buttons.map(btn => {
          const updated = action.payload.find(cat => cat.id === btn.id);
          return updated ? { ...btn, order_number: updated.order_number } : btn;
        }),
      };

    case ActionTypes.ADD_CATEGORY:
      return {
        ...state,
        buttons: [...state.buttons, action.payload],
      };

    case ActionTypes.UPDATE_CATEGORY:
      return {
        ...state,
        buttons: state.buttons.map(btn =>
          btn.id === action.payload.id ? { ...btn, ...action.payload } : btn
        )
      };

    case ActionTypes.DELETE_CATEGORY:
      return {
        ...state,
        buttons: state.buttons.filter(button =>
          button.id !== action.payload && button.parent_id !== action.payload
        ),
      };

    case ActionTypes.TOGGLE_DIRECTORY:
      return {
        ...state,
        directories: state.directories.map((directory) =>
          (directory.id === action.payload)
            ? { ...directory, mobile_enabled: !directory.mobile_enabled }
            : directory
        ),
      };

    case ActionTypes.INCREMENT_NEXT_TEMP_ID:
      return {
        ...state,
        nextTempId: state.nextTempId + 1,
      }

    default:
      return state;
  }
};

export default rootReducer